// extracted by mini-css-extract-plugin
export default {"container":"sort-results_container__vTGEe"};